import { useEnsName } from 'wagmi';

export const useReverseENSLookUp = (address: string) => {
  const { data: ensName } = useEnsName({
    address: address as `0x${string}`,
    enabled: !!address,
  });

  return ensName ?? undefined;
};
